import { useLocation, useParams } from 'react-router';
import { RefObject, useCallback, useMemo } from 'react';
import { FormRef } from '@iress-oss/ids-components';
import { IressFormDataType, Nullable } from '@xplan-pension-switching/common';

const pages = ['current-plan-projections', 'new-investments', 'advisor-charges', 'new-pensions', 'generate-report'];

export const usePageNavigation = (
    formReference: RefObject<Nullable<FormRef<IressFormDataType>>>
): {
    pages: string[];
    search: string;
    currentPage: Nullable<string>;
    nextPage: Nullable<string>;
    previousPage: Nullable<string>;
    onFormSubmit: () => void;
} => {
    const location = useLocation();
    const params = useParams();
    const { section, subsection } = params as { section?: string; subsection?: string };

    const thisSection = section ?? '';
    const thisSectionIndex = pages.findIndex(sectionId => sectionId === thisSection);

    const currentPage = useMemo(() => {
        return pages[thisSectionIndex] ?? null;
    }, [thisSectionIndex]);

    const nextPage = useMemo(() => {
        return (subsection ? pages[thisSectionIndex] : pages[thisSectionIndex + 1]) ?? null;
    }, [subsection, thisSectionIndex]);

    const previousPage = useMemo(() => {
        return (subsection ? pages[thisSectionIndex] : pages[thisSectionIndex - 1]) ?? null;
    }, [subsection, thisSectionIndex]);

    const dispatchForm = useCallback((): void => {
        (async (): Promise<void> => {
            formReference.current?.submit();
        })();
    }, [formReference]);

    const onFormSubmit = useCallback((): void => {
        dispatchForm();
    }, [dispatchForm]);

    return {
        pages,
        search: location.search,
        currentPage,
        nextPage,
        previousPage,
        onFormSubmit,
    };
};
